import React, { useEffect, useRef, useState } from 'react'
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { getTrans as t } from "../../Localization/translations";
import ButtonLoading from '../../components/Loder/buttonLoading';
import AddcategoryService from '../../services/category/categoryAddServices';
import axios from 'axios';
import authHeader from '../../services/auth-header';
import { API } from '../../backend';

const Createcategories = () => {
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const navigate = useNavigate();

  const [category_name, setCategory_name] = useState("")
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [asset_type, setAsset_type] = useState("")
  const [asset_typesetting, setAssetSettingType] = useState("");
  const [asset_typeselection, setAssetTypeSelection] = useState("");


  const [rowsData, setRowsData] = useState([{
    sub_category_name: "",
    is_default: false
  }]);

  const addTableRows = () => {
    const rowsInput = {
      sub_category_name: "",
      is_default: false
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  };

  console.log('rowsData', rowsData)
  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handelClick = () => {
    navigate("/categories");
  };

  const handleRegister = () => {
    setLoading(true);
    setDisable(true)
    let item_type = ""
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddcategoryService.addCategory(
        category_name,
        item_type,
        rowsData
      ).then((response) => {
        if (response.data.success) {
          setLoading(false);
          setTimeout(() => {
            setDisable(false)
            navigate("/categories");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoading(false);
          setDisable(false)
        }
      })
    }
  };

  const handleCheckboxChange = (selectedIndex) => {
    const updatedData = rowsData.map((item, idx) => ({
      ...item,
      is_default: idx === selectedIndex ? true : false,
    }));
    setRowsData(updatedData);
  };

  const asset_number_method = async () => {
    const responseJSON = await axios
      .get(API + `contracts/asser_number_series/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setAsset_type(response.data.assettype.split(", "));
          setAssetSettingType(response.data.assettype);
        } else {
          return false;
        }
      })
  };

  useEffect(() => {
    asset_number_method();
  }, []);

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <div>
            <h5 >{t("Create New Category")}</h5>
            <h6>
              <Link to="/categories" className="tc">
                {t("Category")}
              </Link>{" "}
              / <span>{t("New Category")}</span>{" "}
            </h6>
            <div className="show_invoice">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="success"></div>
                      <Form
                        role="form text-left"
                        onSubmit={handleSubmit(handleRegister)}
                        ref={form}
                        action="."
                        method="POST"
                        id="addcategoryForm"
                      >
                        {
                          <>
                            <div className="row">
                              <div className="col-xl-6">
                                <div className="col-lg-12">
                                  <div className="form-group row">
                                    <div className="col-sm-6">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Category Name")}{" "}
                                        <Tooltip content={t("Category_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="categoryname"
                                        name="categoryname"
                                        {...register("categoryname", {
                                          onChange: (e) => {
                                            setCategory_name(e.target.value);
                                          },
                                          required: true,
                                        })}
                                      ></input>
                                      <div className="invalid-feedback">
                                        {errors.categoryname?.type === "required" &&
                                          "Category Name is required"}
                                      </div>
                                    </div>
                                    {/* <div className="col-sm-6">
                                      <label className="col-form-label required">{t('Item Type')} <Tooltip content={t('ItemType_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                      <select
                                        className="form-control"
                                        name="item_type"
                                        onChange={(e) => setAsset_type(e.target.value)}
                                        {...register("item_type", { onChange: (e) => { setAsset_type(e.target.value) }, required: true })}
                                      >
                                        <option value="">Select Value</option>
                                        <option value="Vehicle">Vehicle</option>
                                        <option value="Equipment">Equipment</option>
                                      </select>
                                      <div className="invalid-feedback">
                                        {errors.item_type?.type === 'required' && "Item Type  is required"}
                                      </div>
                                    </div> */}
                                    
                                    {asset_type.length === 1 ? (
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-6 col-form-label text-left required">
                                          {t("Asset Type")}{" "}
                                          <Tooltip content={t("Assettype_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <input
                                          type="text"
                                          disabled
                                          className="form-control"
                                          value={asset_typesetting}
                                        />
                                      </div>
                                    ) : (
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-6 col-form-label text-left required">
                                          {t("Item Type")}{" "}
                                          <Tooltip content={t("Assettype_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <select
                                          id="frequency"
                                          className="form-control"
                                          name="assettype"
                                          value={asset_typeselection}
                                          {...register("assettype", {
                                            onChange: (e) => {
                                              setAssetTypeSelection(e.target.value);
                                            },
                                            required: true,
                                          })}
                                        >
                                          <option value="">{"Select Item Type"}</option>
                                          <option value="Vehicle">{t("Vehicle")}</option>
                                          <option value="Equipment">
                                            {t("Equipment")}
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.assettype && "Item Type is required"}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row pt-3 align-items-center">
                              <div className="col-xl-6">
                                <label className="col-form-label">{t("Subcategories")}</label>
                              </div>
                              <div className="col-xl-6 d-flex justify-content-end">
                                <div style={{ width: "50%" }}>
                                  <button
                                    type="button"
                                    className="btn btn-outline-success btn-mb w-50"
                                    onClick={addTableRows}
                                  >
                                    + {t("ADD")}
                                  </button>
                                </div>
                              </div>
                            </div>

                            <table
                              id="invoice"
                              className="table table-sm table-nowrap mb-0"
                              style={{ fontSize: "0.875rem" }}
                            >
                              <thead>
                                <tr>
                                  <th>
                                    {t("index")}{" "}
                                    <Tooltip content={t("Index")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Sub Category Name")}{" "}
                                    <Tooltip content={t("Sub_category_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Default")}{" "}
                                    <Tooltip content={t("default_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>

                              <tbody>
                                {rowsData.map((data, index) => (
                                  <tr key={index}>
                                    <td className="align-middle">{index + 1}</td>
                                    <td>
                                      <div style={{ width: "50%" }}>
                                        <input
                                          type="text"
                                          placeholder="Subcategory Name"
                                          value={data.sub_category_name}
                                          onChange={(evnt) => handleChange(index, evnt)}
                                          name="sub_category_name"
                                          className="form-control form-control-sm"
                                          style={{ height: "32px", fontSize: "0.875rem" }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                          type="checkbox"
                                          style={{ width: '30%', height: '15px' }}
                                          checked={data.is_default === true}
                                          onChange={() => handleCheckboxChange(index)}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => deleteTableRows(index)}
                                        style={{ height: "32px", fontSize: "0.75rem" }}
                                      >
                                        x
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <div className="text-left py-3">
                              <button
                                style={{ display: "none" }}
                                type="button"
                                className="complete_invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Complete")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handelClick}
                                className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Cancel")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="submit"
                                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                disabled={disable}
                              >
                                {loading === false ? (
                                  t("Save")
                                ) : (
                                  <ButtonLoading />
                                )}
                              </button>
                              &nbsp;&nbsp;
                            </div>
                          </>
                        }
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn}
                        />
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Createcategories